"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AutomaticTabActivator_1 = require("./AutomaticTabActivator");
var ManualTabActivator_1 = require("./ManualTabActivator");
var TabsWidget_1 = require("./TabsWidget");
var TabActivatorFactory = /** @class */ (function () {
    function TabActivatorFactory() {
    }
    TabActivatorFactory.CreateInstance = function (tabsWidget) {
        var isActivationModeManual = tabsWidget.props.activationMode === TabsWidget_1.TabActivationMode.Manual;
        return isActivationModeManual ? new ManualTabActivator_1.ManualTabActivator(tabsWidget) : new AutomaticTabActivator_1.AutomaticTabActivator(tabsWidget);
    };
    return TabActivatorFactory;
}());
exports.TabActivatorFactory = TabActivatorFactory;
//# sourceMappingURL=TabActivatorFactory.js.map